import React, { Component } from 'react';
import ubicacion from '../icons/ubicacion.svg';
import mail from '../icons/mail.svg';
import headset from '../icons/headset.svg';
import cellphone from '../icons/cellphone.svg';
import brujula from '../icons/brujula.svg';

import facebook from '../icons/fb.svg';
import googlePlus from '../icons/g+.svg';
import linkedin from '../icons/ln.svg';
import twitter from '../icons/twitter.svg';
import instagram from '../icons/instagram.svg';

import '../styles/Footer.css';

class Footer extends Component {
    render() {
        return (
            <div className="Footer">
                <div class="pre-footer-container">
                    <div class="pre-footer">
                        <div class="left-pre-footer">
                            <div class="pre-footer-item">
                                <div class="pre-footer-header">
                                    <p><strong>SERVICIOS</strong></p>
                                </div>
                            </div>
                            <div class="pre-footer-item">Comerciales</div>
                            <div class="pre-footer-item">Logísticos</div>
                            <div class="pre-footer-item">Administrativos</div>
                            <div class="pre-footer-item">Tecnología de la información</div>
                            <div class="pre-footer-item"></div>
                        </div>
                        <div class="right-pre-footer">
                            <div class="pre-footer-item">
                                <div class="pre-footer-header">
                                    <p><strong>CONTACTO</strong></p>
                                </div>
                            </div>
                            <div class="pre-footer-item"><img src={ubicacion} /> Cazadores de Coquimbo 2841 piso 3 -</div>
                            <div class="pre-footer-item"><img src={brujula} /> Munro (Vicente López) - Pcia. Bs. As. - Argentina</div>
                            <div class="pre-footer-item"><img src={cellphone} /> Teléfono conmutador: 54-11-5263-3430</div>
                            <div class="pre-footer-item"><img src={headset} /> Atención al cliente: 0800-362-GLOBAL (4562)</div>
                            <div class="pre-footer-item"><img src={mail} /> Email: atencionalcliente@globalfarm.com.ar</div>
                        </div>
                    </div>
                </div>
                <div class="footer-container">
                    <div class="footer">
                        <div class="left-footer"><strong>Globalfarm</strong> - Logística para laboratorios</div>
                        <div class="right-footer">Argentina - 2018</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js